import * as React from "react";

function SvgDreamdataIo(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 127.6 47.9"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M106.7 0c-11 0-20.2 8.6-20.8 19.7-.5 9-8.3 9.9-12 6.9-4.3-3.5-10.5-3.3-14.6.5-3.5 3.3-9.1 1.9-10-3.8C48.2 16 41.5 11 34.2 12.1c-5.8.9-10.3 5.5-11.2 11.3-1.5 10.7-7.8 11.8-13.5 10.1h-.1c-3.9-1.2-8 1-9.2 4.9s1 8 4.9 9.2c3.9 1.2 8-1 9.2-4.9 1.8-5.7 6.2-10.3 16-5.5 5.1 2.6 11.4 1.5 15.4-2.6 4.1-4.1 9.4-2 10.3 2.7 1.2 6 7 9.9 13.1 8.7 4.4-.9 7.9-4.3 8.7-8.7.9-4.7 7.5-8.9 13.6-2.3 7.8 8.5 21 9 29.5 1.2s9-21 1.2-29.5c-4-4.3-9.5-6.7-15.4-6.7z" />
    </svg>
  );
}

export default React.forwardRef(SvgDreamdataIo);
